/* Subscribe overlay controller (hh-subscribe-overlay.liquid).
   Opens on any [data-hh-subscribe-open] click or the `hh:open-subscribe` event;
   closes on the ×, a scrim click, or Escape. The newsletter {% form 'customer' %}
   reloads the page on submit — we set a sessionStorage flag on submit so the
   overlay re-opens (showing the success state) ONLY when IT was submitted, not the
   footer newsletter form (which shares form.posted_successfully?). */
(function () {
  'use strict';
  var PENDING = 'hh_subscribe_pending';
  var overlay = document.querySelector('[data-hh-subscribe-overlay]');
  if (!overlay) return;

  function open() {
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    // Intentionally do NOT auto-focus the email field — opening the modal should
    // not pre-select/highlight the input. The customer clicks in when ready.
  }
  function close() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hh-subscribe-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-hh-subscribe-close]')) { e.preventDefault(); close(); return; }
    if (e.target === overlay) { close(); }  // scrim click (card clicks don't reach here)
  });
  window.addEventListener('hh:open-subscribe', open);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

  // Mark that THIS form is being submitted, so only its success re-opens the modal.
  var form = overlay.querySelector('form');
  if (form) form.addEventListener('submit', function () {
    try { sessionStorage.setItem(PENDING, '1'); } catch (err) {}
  });

  // On the reloaded page: re-open with the success state only if we submitted here.
  if (overlay.querySelector('[data-hh-subscribe-posted]')) {
    var pending = false;
    try { pending = sessionStorage.getItem(PENDING) === '1'; } catch (err) {}
    if (pending) { try { sessionStorage.removeItem(PENDING); } catch (err) {} open(); }
  }
})();
